module.exports = __webpack_public_path__ + "static/media/YF64_3.aec5d789.jpg";